export const MigrationFlowFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'menu-migrate-filespace-option',
    flagValue: 'on',
};
export const MigrationFlowAdminAccessFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'migration-admin-access',
    flagValue: 'on',
};
export const WorkspaceOnboardingWidgetFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'onboarding-checklist',
    flagValue: 'on',
};
// File preview availability
export const FilePreviewFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'file-preview',
    flagValue: 'on',
};
// Service accounts availability
export const ServiceAccountsFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'service-accounts',
    flagValue: 'on',
};
// Workspace Onboarding Flow
export const WorkspaceOnboardingFlowFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'workspace-onboarding-flow',
    flagValue: 'on',
};
// Add Workspace Button in WorkspaceBar
export const AddWorkspaceButtonFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'add-workspace-button',
    flagValue: 'on',
};
export const UpgradeFilespaceFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'filespace-upgrade',
    flagValue: 'on',
};
export const BlockSizeSelectionFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'block-size-selection',
    flagValue: 'on',
};
export const BlockSizeLucidFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'block-size-lucid',
    flagValue: 'on',
};
// Toggle for parent-domain email remapping on verified domains
export const RemapParentDomainEmailsFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'remap-parent-domain-emails',
    flagValue: 'on',
};
export const FilespaceCreateRoleCredentialsFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'filespace-create-role-credentials',
    flagValue: 'on',
};
// LucidLink Connect availability
export const LucidLinkConnectFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'lucidlink-connect-preview-v2',
    flagValue: 'on',
};
// Folder (batch) download availability
export const FolderDownloadFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'folder-download',
    flagValue: 'on',
};
export const EntryDownloadFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'entry-download',
    flagValue: 'on',
};
export const PartnerMspUpgradeFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'partner-msp-upgrade',
    flagValue: 'on',
};
export const MspPartnerTransferWorkspaceFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'msp-partner-transfer-workspace',
    flagValue: 'on',
};
export const PartnerEnterpriseOrganizationFeatureFlagProperties = {
    flagKey: 'on',
    flagName: 'partner-enterprise-organization',
    flagValue: 'on',
};
